import React, { useCallback } from 'react';
import { MapWithPreloader as Map } from '#component/map';

const ShipmentMap = props => {
  const {
    defaultDevices,
    locations,
    destinations,
    zoomLastLocation,
    clickDevices
  } = props;
  const setMap = useCallback(() => {}, []);

  return (
    <Map
      devices={defaultDevices}
      locations={locations}
      destinations={destinations}
      setMap={setMap}
      isMobile={false}
      zoomLastLocation={zoomLastLocation}
      clickDevices={clickDevices}
      mapClass="dashboardPage"
    />
  );
};

export default ShipmentMap;
